module.exports = "/images/bi.svg?7b20e7458e05d34db5d404fc95fa78cf";